import * as actions from './spawnActions';

const initialState = {
  spawns: [],
  selectedSpawn: null,
  currentSpawn: null,
  currentSpawnLoading: false,
  currentSpawnError: null,
  lineageTree: null,
  lineageLoading: false,
  loading: false,
  error: null,
  success: null,
};

export default function spawnReducer(state = initialState, action) {
  switch (action.type) {
    // CREATE SPAWN
    case actions.CREATE_SPAWN.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case actions.CREATE_SPAWN.SUCCESS:
      return {
        ...state,
        loading: false,
        spawns: [action.payload.data, ...state.spawns],
        success: 'Spawn source created successfully',
      };
    case actions.CREATE_SPAWN.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // UPDATE SPAWN
    case actions.UPDATE_SPAWN.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case actions.UPDATE_SPAWN.SUCCESS:
      return {
        ...state,
        loading: false,
        spawns: state.spawns.map((spawn) =>
          spawn.id === action.payload.data.id ? action.payload.data : spawn
        ),
        selectedSpawn: action.payload.data,
        success: 'Spawn source updated successfully',
      };
    case actions.UPDATE_SPAWN.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // DELETE SPAWN
    case actions.DELETE_SPAWN.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case actions.DELETE_SPAWN.SUCCESS:
      return {
        ...state,
        loading: false,
        spawns: state.spawns.filter((spawn) => spawn.id !== action.payload.id),
        selectedSpawn: null,
        success: 'Spawn source deleted successfully',
      };
    case actions.DELETE_SPAWN.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GET SPAWNS BY ORGANIZATION
    case actions.GET_SPAWNS_BY_ORG.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_SPAWNS_BY_ORG.SUCCESS:
      return {
        ...state,
        loading: false,
        spawns: action.payload.data,
      };
    case actions.GET_SPAWNS_BY_ORG.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // UI STATE
    case actions.SET_SELECTED_SPAWN:
      return {
        ...state,
        selectedSpawn: action.payload,
      };

    case actions.RESET_SPAWNS_STATE:
      return initialState;

    // GET SPAWN DETAIL
    case actions.GET_SPAWN_DETAIL.REQUEST:
      return {
        ...state,
        currentSpawnLoading: true,
        currentSpawnError: null,
      };
    case actions.GET_SPAWN_DETAIL.SUCCESS:
      return {
        ...state,
        currentSpawnLoading: false,
        currentSpawn: action.payload.data,
      };
    case actions.GET_SPAWN_DETAIL.FAILURE:
      return {
        ...state,
        currentSpawnLoading: false,
        currentSpawnError: action.payload,
      };
    case 'CLEAR_SPAWN_DETAIL':
      return {
        ...state,
        currentSpawn: null,
        currentSpawnLoading: false,
        currentSpawnError: null,
      };

    // TOGGLE CONTAMINATION
    case actions.TOGGLE_SPAWN_CONTAMINATION.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.TOGGLE_SPAWN_CONTAMINATION.SUCCESS:
      return {
        ...state,
        loading: false,
        spawns: state.spawns.map((spawn) =>
          spawn.id === action.payload.data.id ? action.payload.data : spawn
        ),
        success: action.payload.data.contamination_free
          ? 'Spawn marked as clean'
          : 'Spawn marked as contaminated',
      };
    case actions.TOGGLE_SPAWN_CONTAMINATION.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // TOGGLE ACTIVE
    case actions.TOGGLE_SPAWN_ACTIVE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.TOGGLE_SPAWN_ACTIVE.SUCCESS:
      return {
        ...state,
        loading: false,
        spawns: state.spawns.map((spawn) =>
          spawn.id === action.payload.data.id ? action.payload.data : spawn
        ),
        success: action.payload.data.active ? 'Spawn activated' : 'Spawn deactivated',
      };
    case actions.TOGGLE_SPAWN_ACTIVE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // TOGGLE DEPLETION
    case actions.TOGGLE_SPAWN_DEPLETION.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.TOGGLE_SPAWN_DEPLETION.SUCCESS:
      return {
        ...state,
        loading: false,
        spawns: state.spawns.map((spawn) =>
          spawn.id === action.payload.data.id ? action.payload.data : spawn
        ),
        success: action.payload.data.is_depleted
          ? 'Spawn marked as depleted'
          : 'Spawn marked as available',
      };
    case actions.TOGGLE_SPAWN_DEPLETION.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GET SPAWN LINEAGE
    case actions.GET_SPAWN_LINEAGE.REQUEST:
      return {
        ...state,
        lineageLoading: true,
        lineageTree: null,
        error: null,
      };
    case actions.GET_SPAWN_LINEAGE.SUCCESS:
      return {
        ...state,
        lineageLoading: false,
        lineageTree: action.payload.data,
      };
    case actions.GET_SPAWN_LINEAGE.FAILURE:
      return {
        ...state,
        lineageLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
